import axios from 'axios'

const bsoNo = function(value) {
  if (value === '' || value.length < 3) return true

  return axios({
    method: 'get',
    responseType: 'json',
    url:
      '/ax26hrxl857-a/components/icformozn/connector.php',
    params: {
      action: 'checkbso',
      bsoNo: value
    }
  }).then(res => {
    if (res.data.success) {
      return true
    } else {
      return false
    }
  })
}

export default bsoNo
